// extracted by mini-css-extract-plugin
export default {"external":"a2xgFA","hint":"b2xgFA","hintWrapper":"c2xgFA","inline":"d2xgFA","popover":"e2xgFA"};